import {Alert, AlertTitle, Button, ButtonGroup, Grid2, Paper, Stack} from "@mui/material";
import React, {useContext, useEffect, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {
    AccountBalance,
    AcUnit,
    AssignmentInd,
    AssignmentLate,
    Business,
    CalendarMonth,
    HolidayVillage,
    HowToReg
} from "@mui/icons-material";
import Main from "../Layout/Main";
import AuthContext from "../Services/AuthContext";
import AlertSignButtons from "../Layout/AlertSignButtons";
import RegisterChildren from "../Panel/Camp/RegisterChildren";
import {
    AdmonitionDirectiveDescriptor,
    directivesPlugin,
    headingsPlugin,
    listsPlugin,
    markdownShortcutPlugin,
    MDXEditor,
    quotePlugin,
    tablePlugin
} from '@mdxeditor/editor'
import '@mdxeditor/editor/style.css'

function Camp() {
    const [user] = useContext(AuthContext);
    const params = useParams();
    const [camp, setCamp] = useState({});
    const [refresh, setRefresh] = useState(0);
    const [editor, setEditor] = useState(null);

    const [register, setRegister] = useState(false);

    useEffect(() => {
        const abortController = new AbortController();

        async function fetchData() {
            await fetch(`/api/global/camp/${params.id}`, {
                method: 'GET',
                signal: abortController.signal,
            }).then(res => res.json())
                .then(data => {
                    setCamp(data);
                    if(data.description) {
                        setEditor(<MDXEditor markdown={data.description} className={'announcement'} readOnly={true} plugins={[
                            directivesPlugin({directiveDescriptors: [AdmonitionDirectiveDescriptor]}),
                            headingsPlugin(),
                            quotePlugin(),
                            listsPlugin(),
                            tablePlugin(),
                            markdownShortcutPlugin(),
                        ]} />);
                    }
                })
                .catch(err => {
                    console.log(err)
                })
        }

        fetchData();
        return () => abortController.abort();
    }, [params.id, refresh]);

    const actions = user.token ? <Button variant={'contained'} onClick={() => setRegister(params.id)} startIcon={<HowToReg />}>Zapisz dziecko</Button> : <AlertSignButtons alert={'By się zapisać na wydarzenie'} />

    return (<Main title={camp?.camp ?? <>&nbsp;</>} actions={actions}>
        <Paper elevation={24} sx={{maxWidth: '95vw', width: '1200px', padding: '10px 30px'}}>
            <Grid2 container className={'features'} flexDirection={'column'}>
                <Stack flexDirection={'row'}>
                    <Button color={'info'} size={'large'} startIcon={<CalendarMonth />}> Od: {camp.start_date} do {camp.end_date}</Button>
                    <Link to={`/q/${camp.organization}`}><Button color={'info'} size={'large'} startIcon={<Business />}> Organizator: {camp.organization}</Button></Link>
                </Stack>
                <Stack flexDirection={'row'}>
                    <Button color={'anthracite'} startIcon={<HolidayVillage />}>Kategoria : {camp.type}</Button>
                    <Link to={`/q/${camp.organizer}`}><Button color={'anthracite'} startIcon={<AccountBalance />}>Miejsce: {camp.organizer}</Button></Link>
                    <Link to={`/q/${camp.season}`}><Button color={'anthracite'} startIcon={<AcUnit />}>Sezon: {camp.season}</Button></Link>
                </Stack>
                <Stack flexDirection={'row'}>
                    <Button color={'anthracite'} startIcon={<AssignmentInd />}>Rejestracja od: {camp.registration_start}</Button>
                    <Button color={'anthracite'} startIcon={<AssignmentLate />}>Rezerwowi od: {camp.registration_end}</Button>
                </Stack>
            </Grid2>
            {camp.quota > 0 && <Alert severity={"warning"}>W ramach {camp.season} możesz automatycznie zapisać się na {camp.quota} dni. Kolejne zgłoszenia trafią na listę rezerwową</Alert>}
            {camp.advanced > 0 && user.token && <Alert sx={{mt: 3}} severity={"warning"} variant={'standard'} action={
                <Link to={`/season/${camp.season_id}/advanced`}><Button color="warning" variant={'outlined'} size="large">
                    Sprawdź dokumenty
                </Button></Link>
            }>W ramach {camp.season} wymagane jest przygotowanie przed zapisem dokumentów elektronicznie.</Alert>}
            {editor}
            {camp.spots !== null && <ButtonGroup>
                <Button color={'warning'} variant={'outlined'}>Pozostalo {camp.spots} miejsc</Button>
                <Button color={'error'} variant={'outlined'}>Rezerwowi: {camp.reserve}</Button>
            </ButtonGroup>}
        </Paper>
        <RegisterChildren data={register} dismiss={() => setRegister(false)} onSuccess={() => setRefresh(r => ++r)} />
    </Main>);
}

export default Camp;